import { map, type Observable } from 'rxjs'
import type { IBehaviorObservable, IWrappedBehaviorObservable } from './IBehaviorObservable'

export class PipedBehaviorObservable<T, K> implements IWrappedBehaviorObservable<T> {
  public observable$: Observable<T>
  public value: T

  constructor(observable: IBehaviorObservable<K>, project: (k: K) => T) {
    this.observable$ = observable.pipe(
      map((k) => {
        const value = project(k)
        this.value = value
        return value
      }),
    )
    this.value = project(observable.value)
  }
}
